import React from 'react';
import { translate } from 'react-i18next';
import { Image, StyleSheet, Text, View } from 'react-native';
import Theme from '../../theme';
import { defaultScale, scaleText } from '../../utils/scaling';

class TrackingGaugeLegend extends React.PureComponent<any, any> {
    public render() {
        const { t } = this.props;
        return (
            <View style={styles.container}>
                <View style={styles.keyContainer}>
                    <Image
                        style={styles.circle}
                        source={require('../../assets/images/legend-green.png')}
                    />
                    <Text style={styles.goodText}>{t('good')}</Text>
                </View>
                <View style={styles.keyContainer}>
                    <Image
                        style={styles.circle}
                        source={require('../../assets/images/legend-orange.png')}
                    />
                    <Text style={styles.averageText}>{t('tooHigh')}</Text>
                </View>
                <View style={styles.keyContainer}>
                    <Image
                        style={styles.circle}
                        source={require('../../assets/images/legend-red.png')}
                    />
                    <Text style={styles.badText}>{t('bad')}</Text>
                </View>

            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        alignContent: 'center',
        justifyContent: 'space-evenly',
        flexDirection: 'row',
        paddingTop: defaultScale(8),
        paddingBottom: defaultScale(10),
        backgroundColor: Theme.WHITE,
        borderTopWidth: defaultScale(1),
        borderTopColor: Theme.GREY_LIGHT,
    },
    goodText: {
        fontSize: scaleText(13),
        color: '#1ED930',
        fontFamily: Theme.Custom400,
        marginLeft: defaultScale(4),
    },
    averageText: {
        fontSize: scaleText(13),
        color: '#FFA400',
        fontFamily: Theme.Custom400,
        marginLeft: defaultScale(4),
    },
    badText: {
        fontSize: scaleText(13),
        color: '#FF3D20',
        fontFamily: Theme.Custom400,
        marginLeft: defaultScale(4),
    },
    circle: {
        width: defaultScale(18),
        height: defaultScale(18),
        marginTop: defaultScale(1),
    },
    keyContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
});

export default translate(['workoutHistory'])(TrackingGaugeLegend);
